import { faFile } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import { Col, Row } from "reactstrap";
import { isOlderThen, ShowError } from "../../../_helper/helper";
import Errorlable from "./Errorlable";

const relationArray = [
  { label: "Spouse", year: "Spouse" },
  { label: "Domestic Partner", year: "Domesticpartner" },
  { label: "Child", year: "Child" },

];

const RelationArray = [

  {
    name: "Spouse",
    value: "Spouse"
  },
  {
    name: "Domestic Partner",
    value: "Domesticpartner"
  },
  {
    name: "Child",
    value: "Child"
  },

]

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },
    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const DocumentViewer = (props) => {
  const { open, setOpen, fullWidth, getBenefitsData, fullScreen, fieldName, selfData = {}, handleDependentUpdate } = props;

  const handleClose = () => setOpen(false);
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState({
    empDetail: true,
    healthandDeduction: true,
    dependent: true,
  });
  const [dependentInformation, setDependentInformation] = React.useState({
    firstName: "",
    lastName: "",
    middleName: "",
    mailingAddress: "",
    email: "",
    dob: null,
    relation: "",
    gender: "",
    ssn: ""
  });
  const [errors, setErrors] = React.useState({});

  React.useEffect(() => {
    if (selfData) {
      setDependentInformation({ ...dependentInformation, lastName: selfData?.lastName, middleName: selfData?.middleName?.[0] })
    }
  }, [selfData])

  const renderCheckbox = (size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={dependentInformation[stateName] == value}
        onChange={(e) => {
          setDependentInformation({ ...dependentInformation, [stateName]: value });
        }}
      />
    );
  };

  function renderPasswordInput(

    stateName,
    label,
    others = {
      disabled: false,
      multiline: false,
      required: false,
      maxLength: "",
      shrink: true,
    }
  ) {
    let other = {
      disabled: false,
      multiline: false,
      required: false,
      shrink: true,
      ...others,
    };

    let { disabled, multiline, required, shrink, width, maxLength } = other;
    return (

      <FormControl sx={{ mt: 2 }} variant="outlined" style={{ width: "100%" }}>
        <InputLabel //error={!disabled && required && !dependentInformation?.[stateName] ? true : dependentInformation?.[stateName].length != 9 ? true : false}
          required shrink={true} htmlFor="outlined-adornment-password">{label}</InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type={dependentInformation?.["isSSN"] ? "text" : "password"}
          size="small"
          inputProps={{
            maxLength: maxLength,
            readOnly: disabled,
          }}
          notched={true}
          fullWidth
          name={stateName}
          value={dependentInformation[stateName]}
          // InputLabelProps={{ shrink: other.shrink ? other.shrink : false }}
          onChange={(e) => {
            setDependentInformation({ ...dependentInformation, [stateName]: e.target.value })
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => {

                  setDependentInformation({ ...dependentInformation, isSSN: !dependentInformation.isSSN });
                }}
                edge="end"
              >
                {dependentInformation?.["isSSN"] ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          label={label}
        />
      </FormControl>
    );
  }
  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null,
    required = false
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}

          // maxDate={maxDate}
          value={dependentInformation?.[stateName] ? dependentInformation?.[stateName] : null}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD")
              : null;
            setDependentInformation({ ...dependentInformation, [stateName]: date });
          }}
          // onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              style={{ width: "100%" }}

            />
          )}
        />
      </LocalizationProvider>
    );
  }

  const handleSubmitData = () => {
    let errors = {};
    if (!dependentInformation.firstName) {
      errors.firstName = "First Name is required";
    }
    if (!dependentInformation.middleName) {
      errors.middleName = "middleName is required";
    }
    if (!dependentInformation.lastName) {
      errors.lastName = "lastName is required";
    }
    // if (!dependentInformation.dob) {
    //   errors.dob = "dob is required";
    // }

    if (dependentInformation?.dob && isOlderThen(dependentInformation?.dob) && dependentInformation?.relation == 'Child') {
      errors.dob = "Child Should be not more than 26 years";
    }
    if (dependentInformation.ssn?.length == 4 || dependentInformation.ssn?.length == 9) {
      delete errors.ssn
    } else {
      errors.ssn = "ssn must be exactly 9 or 4 characters";
    }
    if (!dependentInformation.gender) {
      errors.gender = "gender is required";
    }
    if (!dependentInformation.relation) {
      errors.relation = "Relation is required";
    }

    setErrors(errors);

    if (Object.keys(errors).length) {
      return false
    } else {
      let payload = {
        "firstName": dependentInformation?.firstName,
        "lastName": dependentInformation?.lastName,
        "middleName": dependentInformation?.middleName,
        "mailingAddress": dependentInformation?.mailingAddress,
        "email": dependentInformation?.email,
        "gender": dependentInformation?.gender,
        "ssn": dependentInformation?.ssn,
        "dob": dependentInformation?.dob,
        "relation": dependentInformation?.relation,
        fieldName: fieldName,
        [fieldName]: selfData?.SubscriberID,

      }
      if (fieldName == 'dentalSubscriberId' || fieldName == 'DentalSubscriberID') {
        payload['dentalType'] = dependentInformation?.relation;
        payload['dependentfor'] = 'Dental';

      } else if (fieldName == 'healthSubscriberId' || fieldName == 'HealthSubscriberID') {
        payload['healthType'] = dependentInformation?.relation
        payload['dependentfor'] = 'Health';
      }
      axios
        .post(
          `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateBenefits`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then(async (response) => {
          // ShowSucess("Successfully Created.");
          // response?.data?.data ||
          const isOpration = response?.data?.status
          const res = response?.data?.data
          let payload = isOpration == "Added" ?
            {
              ...res,
              // "Dependants": "Health Dependants",
              "role": (fieldName == 'healthSubscriberId' || fieldName == 'HealthSubscriberID') ? "Health" : "Dental",
              "EmpId": "",
              "rowId": res?.id,
              "TotalCount": "",
              HealthSubscriberID: res?.healthSubscriberId,
              DentalSubscriberID: res?.dentalSubscriberId
            }
            : {}

          await handleDependentUpdate(payload)
          setOpen(!open)
          // getBenefitsData()
        })
        .catch((error) => {
          ShowError(error?.response?.data?.error);
        });
    }

    return errors;
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      onClick={(e) => e.stopPropagation()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={fullWidth}
      maxWidth={"md"}
      //   maxWidth={maxWidth}
      // PaperProps={{
      //   sx: {
      //     height: "100%",
      //   },
      // }}
      fullScreen={fullScreen}
    // style={{ zIndex: "99999" }}
    >
      <Grid className="d-flex justify-content-end align-items-center">
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <DialogTitle id="id" style={{ padding: "0 !important" }} className="pb-0">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          className="bg-primary rounded py-1 mb-3"
        >
          <Typography variant="h6" fontWeight={500}>
            <FontAwesomeIcon icon={faFile} className="m-r-10" />
            Add Dependent
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent
        className="h-100"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Card style={{ marginTop: "10px" }}>
          <Row style={{ padding: "10px" }}>
            <Col md={4} style={{ marginTop: "5px" }}>
              <TextField
                id="firstName"
                name="firstName"
                size="small"
                fullWidth
                margin="dense"
                value={dependentInformation.firstName || ""}
                onChange={(e) =>
                  setDependentInformation({
                    ...dependentInformation,
                    firstName: e.target.value,
                  })
                }
                label="First Name"
                variant="outlined"
              />
              <Errorlable text={errors.firstName} />
            </Col>
            <Col md={4} style={{ marginTop: "5px" }}>
              <TextField
                id="middleName"
                name="middleName"
                size="small"
                fullWidth
                margin="dense"
                value={dependentInformation?.middleName}
                onChange={(e) => {
                  setDependentInformation({
                    ...dependentInformation,
                    middleName: e.target.value,
                  });
                }}
                label="middleName"
                variant="outlined"
                inputProps={{
                  maxLength: 1,
                }}
              />
              <Errorlable text={errors.middleName} />
            </Col>

            <Col md={4} style={{ marginTop: "5px" }}>
              <TextField
                id="lastName"
                name="lastName"
                size="small"
                margin="dense"
                fullWidth
                value={dependentInformation?.lastName}
                onChange={(e) => {
                  setDependentInformation({
                    ...dependentInformation,
                    lastName: e.target.value,
                  });
                }}
                label="LastName"
                variant="outlined"
              />
              <Errorlable text={errors.lastName} />
            </Col>

            <Col md={4} style={{ marginTop: "5px" }}>
              <div style={{ display: "flex", marginRight: "5px" }}>
                <span style={{ display: "flex" }}>
                  <span>{renderCheckbox("medium", "gender", "Male")} </span>
                  <span style={{ alignSelf: "center" }}>Male</span>
                </span>
                <span style={{ display: "flex" }}>
                  <span>{renderCheckbox("medium", "gender", "Female")} </span>
                  <span style={{ alignSelf: "center" }}> Female</span>
                </span>
                <span style={{ display: "flex" }}>
                  <span>{renderCheckbox("medium", "gender", "Other")} </span>
                  <span style={{ alignSelf: "center" }}> Other </span>
                </span>
              </div>
              <div>

              </div>
              <Errorlable text={errors.gender} />
            </Col>
            <Col md={4}>
              {renderPasswordInput("ssn", "SSN", {
                maxLength: 9,
                required: true,
              })}
              <Errorlable text={errors.ssn} />
            </Col>
            <Col md={4}>
              <Autocomplete
                size="small"
                disablePortal
                id="combo-box-demo"
                className="mt-2"
                fullWidth
                style={{ width: "100%" }}
                value={dependentInformation?.relation}
                onChange={(e, value) => {
                  setDependentInformation({ ...dependentInformation, relation: value?.year })
                }}
                options={relationArray}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField {...params} label="Relation" fullWidth margin="dense" style={{ width: "100%" }} />
                )}
              />
              <Errorlable text={errors.relation} />
            </Col>
            <Col md={4} style={{ marginTop: "8px" }}>
              {renderDateInput("dob", "Date of Birth")}
              <Errorlable text={errors.dob} />
            </Col>
            <Col md={4} style={{ marginTop: "8px" }}>
              <TextField
                id="mailingAddress"
                name="mailingAddress"
                size="small"
                margin="dense"
                fullWidth
                value={dependentInformation?.mailingAddress}
                onChange={(e) => {
                  setDependentInformation({
                    ...dependentInformation,
                    mailingAddress: e.target.value,
                  });
                }}
                label="Mailing Address"
                variant="outlined"
              />
            </Col>
            <Col md={4} style={{ marginTop: "8px" }}>
              <TextField
                id="email"
                name="email"
                size="small"
                margin="dense"
                fullWidth
                value={dependentInformation?.email}
                onChange={(e) => {
                  setDependentInformation({
                    ...dependentInformation,
                    email: e.target.value,
                  });
                }}
                label="Email Address"
                variant="outlined"
              />
            </Col>
            <Row>
              <Col md={6}>
                <Button
                  onClick={(e) => handleSubmitData()}
                  style={{ color: "white" }}
                  variant="fill"
                  className="btn btn-primary ml-2 mt-3"
                >
                  Update Coverage
                </Button>
              </Col>
            </Row>
          </Row>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentViewer;
